module.exports = __webpack_public_path__ + "img/circle-icon.ca4da1dc.svg";